/** 计费接口返回 402 时的提示: 管理员给充值入口, 普通成员提示联系管理员 */
import { Link } from "react-router-dom";
import { useAuthStore } from "@/stores/auth-store";
import { Alert } from "@/components/ui/Alert";

export function InsufficientCreditsNotice() {
  const isAdmin = useAuthStore((s) => s.isAdmin)();
  const role = useAuthStore((s) => s.user?.role);
  return (
    <Alert>
      余额不足，
      {isAdmin && role !== "super_admin" ? (
        <Link to="/billing" className="font-medium underline underline-offset-2">去充值</Link>
      ) : (
        "请联系公司管理员充值"
      )}
    </Alert>
  );
}
